import { type SortColumn } from "owa-mail-list-store";

export default function isJumpToTextInputSort(sortColumn: SortColumn | undefined): boolean {
    return (sortColumn === 3 ||
        sortColumn === 9 ||
        sortColumn === 8);
}
